import React, { useState } from "react";

function Login({ onLogin, goToRegister }) {
  const [loginId, setLoginId] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = () => {
    if (!loginId || !password) {
      setError("Please enter Login ID and Password");
      return;
    }
    setLoading(true);
    fetch("/api/auth/login", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ loginId, password }),
    })
      .then((r) => r.json())
      .then((data) => {
        setLoading(false);
        if (data.message === "Login successful") {
          localStorage.setItem("user", JSON.stringify(data));
          onLogin(data);
        } else {
          setError(data.message || "Login failed");
        }
      })
      .catch(() => {
        setLoading(false);
        setError("Server error — please try again");
      });
  };

  const inputStyle = {
    width: "100%",
    padding: "10px 12px",
    background: "#C2B067",
    border: "1px solid #856A00",
    borderRadius: "6px",
    color: "#403301",
    fontSize: "14px",
    fontFamily: "Arial",
    boxSizing: "border-box",
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#f8f9fa",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "Arial",
      }}
    >
      <div style={{ width: "380px" }}>
        {/* Logo + Title */}
        <div style={{ textAlign: "center", marginBottom: "32px" }}>
          <img
            src="https://botmotautomations.com/wp-content/uploads/2025/06/cropped-cropped-Logo-1-1-50x38.png"
            alt="BotMot Logo"
            style={{ width: "60px", marginBottom: "12px" }}
          />
          <div
            style={{ fontSize: "24px", fontWeight: "bold", color: "#856A00" }}
          >
            Swarna
          </div>
          <div style={{ fontSize: "12px", color: "#928243", marginTop: "4px" }}>
            by BotMot Automations
          </div>
        </div>

        {/* Card */}
        <div
          style={{
            background: "#928243",
            border: "1px solid #856A00",
            borderRadius: "12px",
            padding: "28px",
          }}
        >
          <h3
            style={{ margin: "0 0 20px 0", color: "#403301", fontSize: "16px" }}
          >
            Login to your account
          </h3>

          {error && (
            <div
              style={{
                background: "#fff0f0",
                border: "1px solid #ef4444",
                borderRadius: "6px",
                padding: "10px 12px",
                marginBottom: "16px",
                fontSize: "13px",
                color: "#ef4444",
              }}
            >
              {error}
            </div>
          )}

          <div style={{ marginBottom: "14px" }}>
            <label
              style={{
                fontSize: "12px",
                color: "#403301",
                display: "block",
                marginBottom: "4px",
              }}
            >
              Login ID
            </label>
            <input
              placeholder="Enter your login ID"
              value={loginId}
              onChange={(e) => setLoginId(e.target.value)}
              style={inputStyle}
            />
          </div>

          <div style={{ marginBottom: "20px" }}>
            <label
              style={{
                fontSize: "12px",
                color: "#403301",
                display: "block",
                marginBottom: "4px",
              }}
            >
              Password
            </label>
            <input
              type="password"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && handleLogin()}
              style={inputStyle}
            />
          </div>

          <button
            onClick={handleLogin}
            disabled={loading}
            style={{
              width: "100%",
              background: "#856A00",
              color: "gold",
              border: "none",
              padding: "11px",
              borderRadius: "6px",
              cursor: "pointer",
              fontSize: "14px",
              fontWeight: "bold",
            }}
          >
            {loading ? "Logging in..." : "Login"}
          </button>

          <div
            style={{
              textAlign: "center",
              marginTop: "16px",
              fontSize: "13px",
              color: "#403301",
            }}
          >
            New user?{" "}
            <span
              onClick={goToRegister}
              style={{
                color: "#856A00",
                cursor: "pointer",
                fontWeight: "bold",
              }}
            >
              Register here
            </span>
          </div>
        </div>

        <div
          style={{
            textAlign: "center",
            marginTop: "20px",
            fontSize: "11px",
            color: "#928243",
          }}
        >
          Powered by BotMot Automations · Bhutani Corp
        </div>
      </div>
    </div>
  );
}

export default Login;
